import React, { useState } from 'react';
import envelope from '../../../icons/envelope.svg';
import { connect } from 'react-redux';
import ProductComponent from './ProductComponent/ProductComponent';
import PopUpInfo from '../../../partials/PopUpInfo/PopUpInfo';
import PopUp from '../../../../../Shared/Popup/PopUp';
import { setInfoPopUP, setIsShowPopUp } from '../../../PersonalAreaInvoicesSlice';

const InfoProducts = (props) => {
  if (!props.detailsProducts || props.detailsProducts.length === 0) return null;

  const renderBodyContent = (item, subscribers, nameProduct) => {
    return <ProductComponent detailsProduct={item} subscribers={subscribers} nameProduct={nameProduct} />;
  };

  const totalPriceBeforeVAT = (allDalDetailsCli , isExempt, fullPriceAfterVat) => {

    if(isExempt){
      return fullPriceAfterVat;
    }

    const totalAmount1 = allDalDetailsCli.reduce((sum, item) => {
      const isBundleEnergyCredit = props.isEnergy && item.listSubPage?.some(x => x.listDalDetailsCliSection?.some(section => section?.listCliDetail?.some(detail => detail?.isBundleEnergy)));
      const price = isBundleEnergyCredit ? 0 : parseFloat((item.amountData?.price || '0').replace(/,/g, ''));
      return sum + price;
    }, 0);

    if(totalAmount1 == 0){
      const totalAmount2  = allDalDetailsCli.reduce((sum, item) => {
      const isBundleEnergyCredit = props.isEnergy && item.listSubPage?.some(x => x.listDalDetailsCliSection?.some(section => section?.listCliDetail?.some(detail => detail?.isBundleEnergy)));
      const price = isBundleEnergyCredit ? 0 : parseFloat((item.priceBeforeVatData?.price || '0').replace(/,/g, ''));
      return sum + price;
      }, 0);

      return Number(totalAmount2 ).toLocaleString();
    }
    else{
      return Number(totalAmount1).toLocaleString();
    }
  };

  const priceVAT = (allDalDetailsCli, priceBeforeVat , priceAfterVat) => {
    let formattedWithComma = null;

    if (allDalDetailsCli.some(item => item.vatData == null || item.vatData.price == null)) {
      // Handle missing VAT data
      if(priceAfterVat && priceBeforeVat){
        let totalVAT = Number(priceAfterVat?.replace(/,/g, '')) - Number(priceBeforeVat?.replace(/,/g, ''));
        formattedWithComma = totalVAT === 0 ? 0 : Number(totalVAT).toLocaleString();
      }
    }
    else{
        // Sum the price property from each item's vatData
        let totalVAT = allDalDetailsCli.reduce((sum, item) => {
        const vat = item.vatData?.price != null
          ? parseFloat(item.vatData.price.replace(/,/g, ''))
          : 0;
        return sum + vat;
        }, 0);

        formattedWithComma = totalVAT === 0 ? 0 : Number(totalVAT).toLocaleString();
    }
    return formattedWithComma;
  };

  const clickPopUp = (data, title) => {
    props.setInfoPopUP({ data, title });
    props.setIsShowPopUp(true);
  };

  return (
    <div className='wrapper-info-products'>
      {props.detailsProducts && props.detailsProducts[0]?.allDetailsCliProduct?.map((product, i) => {
        const nameProduct = product.titleText;
        const nameProductEng = product.detailsType.toUpperCase();
        const isEnergy = nameProductEng === 'ENERGY' ;
        const hasMoreProducts = props.detailsProducts[0]?.allDetailsCliProduct?.length > 1 ;
        const fitcher = props.invoicesInfo?.generalTab?.fitcherData?.fitcher?.find(item => item.title.toUpperCase() === nameProductEng);
        const isExempt =  !product.isExempt ? false : product.isExempt; //פטור ממע"מ
        const isAbroad =  product.detailsType.toUpperCase() === 'ABROAD' ;
        const isPriceBeforeVat =  product.allDalDetailsCli?.some(x => x.listSubPage?.length > 0 && x.listSubPage[0].isPriceBeforeVat) ;
        const isDisplayVat = ( isEnergy || props.invoicesMain?.isCustomerBusiness ) && !isAbroad  &&  (isPriceBeforeVat || isExempt) ;
        const isDisplayFullPriceAfterVat = ( isEnergy && ( isPriceBeforeVat || isExempt || hasMoreProducts)) || !isEnergy ;

        const fullPriceAfterVat =  isDisplayFullPriceAfterVat && fitcher?.amountFitcher?.price ? Number((fitcher?.amountFitcher?.price).replace(/,/g, '')).toLocaleString() : null ;
        const fullPriceBeforeVAT = isDisplayVat ?  totalPriceBeforeVAT(product.allDalDetailsCli, isExempt, fullPriceAfterVat) : null;
        const fullPriceVat = isDisplayVat ? priceVAT(product.allDalDetailsCli , fullPriceBeforeVAT , fullPriceAfterVat) : null;

        const isDisplayFooter =  fullPriceAfterVat != null ;

        return (
          product.allDalDetailsCli.length >= 1 && (
            <div key={i} id={`section-${i}`}>
              <div className='header-info-product'>
                <div className='name-product'>{nameProduct}
                  { fitcher?.countFitcher > 1 && <span className='number-subscribers'>({fitcher.countFitcher} {isEnergy ? 'מונים' : 'מנויים'})</span>}
                  { fitcher?.addName && <span className='name-details'>{fitcher.addName}</span>}
                  </div>
                {product.allDalDetailsCli.length === 1 && !isEnergy && (
                  <div className='personal-information'>
                    {/* {product.allDalDetailsCli[0].isRequestExists &&
                      (product.detailsType !== 'CELLULAR' && product.detailsType.toUpperCase() !== 'ABROAD') && (
                        <button onClick={() => clickPopUp(product.allDalDetailsCli[0].listRequestText, 'ההודעות שלך')} className='link'>
                          הודעות
                        </button>
                      )} */}
                    {product.allDalDetailsCli[0].isPlanDtlExists &&
                      (product.detailsType !== 'CELLULAR' && product.detailsType.toUpperCase() !== 'ABROAD') && (
                        <button onClick={() => clickPopUp(product.allDalDetailsCli[0].listPlanDtlText, 'התוכנית שלך')} className='link'>
                          התוכנית שלך
                        </button>
                    )}
                  </div>
                )}
              </div>
              <div className='body-info-product'>
                {product.allDalDetailsCli.map((item, i) => {
                    return (
                        <div key={i}>
                            {renderBodyContent(item, product.allDalDetailsCli, nameProductEng)}
                        </div>
                    );
                })}
                {isDisplayFooter && (
                  <div className='footer-product'>
                    <hr className='hr-border-top'></hr>
                    <div className='price-wrapper'>
                      { ( fullPriceBeforeVAT != null ) &&
                        <div className='wrapper-total price-before-VAT'>
                          <div className='wrapper'>
                            <div>
                              <div>סה"כ (לפני מע"מ)</div>
                              <div className='price'>₪{fullPriceBeforeVAT}</div>
                            </div>
                          </div>
                        </div>
                      }

                      { ( fullPriceVat != null ) &&
                        <div className='wrapper-total price-VAT'>
                          <div className='wrapper'>
                              <div>
                                <div>סה״כ מע״מ</div>
                                <div className='price'>{isExempt ? 'פטור ממע"מ' : `₪${fullPriceVat}`}</div>
                              </div>
                          </div>
                        </div>
                      }

                      <div className='wrapper-total'>
                        <div>{product.detailsType.toUpperCase() === 'ABROAD' ? 'סה\"כ (פטור ממע\"מ)' : 'סה"כ (כולל מע"מ)'}</div>
                            <div>
                              <div className='price'>₪{fullPriceAfterVat}</div>
                            </div>
                      </div>
                    </div>
                    {/* <div className='note-text'>{product.detailsType.toUpperCase() === 'ABROAD' || isExempt ? 'סה"כ (פטור ממע"מ)' : '*הסכומים כוללים מע"מ'}</div> */}
                  </div>
                )}
              </div>
            </div>
          )
        );
      })}
          {props.invoicesMain?.listDebtData?.length >= 1 && props.invoicesMain?.listDebtData?.map((item, i) => (
            <div className='footer-info-products debt' key={i}>
                <div className='wrapper-footer-products'>
                    <div>{item?.amountText}</div>
                    <div className='price'>
                        ₪{item?.amount}.{item?.amountAgorot}
                        {item?.isAmountMinus && <div className='price-range'>-</div>}
                    </div>
                </div>
            </div>
          ))}

          {props?.invoicesMain?.amountData && (
            <div className='footer-info-products'>
              <div className='wrapper-footer-products'>
                <div>סה"כ תשלומים</div>
                <div className='price'>
                  ₪{props?.invoicesMain?.amountData?.amount}.{props?.invoicesMain?.amountData?.amountAgorot}
                  {props?.invoicesMain?.amountData?.isAmountMinus && <div className='price-range'>-</div>}
                </div>
              </div>
            </div>
          )}

          <PopUp showPopUp={props.isShowPopUp} onClose={() => props.setIsShowPopUp(false)}>
            <PopUpInfo></PopUpInfo>
          </PopUp>
        </div>
      );
    };

const mapStateToProps = (state) => {
  return {
    detailsProducts: state.personalAreaInvoicesPage.detailsProducts,
    invoicesMain: state.personalAreaInvoicesPage.invoicesInfo.main,
    dataPopUp: state.personalAreaInvoicesPage.dataPopUp,
    titlePopUp: state.personalAreaInvoicesPage.titlePopUp,
    invoicesInfo: state.personalAreaInvoicesPage.invoicesInfo,
    isShowPopUp: state.personalAreaInvoicesPage.isShowPopUp,
    isEnergy: state.personalAreaInvoicesPage.isEnergy
  };
};

const mapDispatchToProps = {
  setInfoPopUP,
  setIsShowPopUp,
};

export default connect(mapStateToProps, mapDispatchToProps)(InfoProducts);
